import { TextColor } from '@setvi/shared/enums';
import { IntelligenceAccountProgressStatus } from '../types';

export enum IntelligenceColorMap {
  // background
  BackgroundNeutral = '#EEF0F2',
  BackgroundBrand = '#1E96FC',
  BackgroundNegative = '#FA2020',
  BackgroundBrandSubtle = '#EBF5FF',
  BackgroundBrandHover = '#0b67b5',
  BackgroundSubtle = '#F8F9FA',
  BackgroundPrimary = '#FFFFFF',
  BackgroundInverse = '#20262D',
  BackgroundPrimaryHover = '#f9f9f9',
  BackgroundSubTabActive = '#D2EAFE',
  BackgroundSubTabHover = '#007fff14',
  BackgroundPositiveSubtle = '#E6FAF0',
  BackgroundPositiveSubtleHover = '#CDF4E1',
  BackgroundNegativeSubtle = '#FED2D2',
  BackgroundWarning = '#F08B0F',
  BackgroundWarningSubtle = '#FCE8CF',
  BackgroundPressed = '#E8ECEE',
  BackgroundPressedHover = '#eef1f3',
  // text
  TextBrand = '#1E96FC',
  TextMain = TextColor.Main,
  TextLink = '#1E96FC',
  TextWarning = '#F08B0F',
  TextPrimary = '#20262D',
  TextPrimaryInverse = '#F8F9FA',
  TextNegative = '#FA2020',
  TextPositive = TextColor.Green,
  TextPositivePressed = '#15653F',
  TextTertiary = TextColor.SlateGrey,
  TextTertiaryInverse = '#E8ECEE',
  TextSecondary = '#333D47',
  TextSecondaryInverse = '#EEF0F2',
  // icon
  IconGold = '#F08B0F',
  IconBrand = '#1E96FC',
  IconSubtle = '#5D7083',
  IconPositive = '#23A566',
  IconNegative = '#FA2020',
  IconWarning = '#F08B0F',
  IconInverseStatic = '#F8F9FA',
  // border
  BorderPrimary = '#AFBAC6',
  BorderSubtle = '#EEF0F2'
}

export const AccountProgressStatusToTextColor: Record<
  IntelligenceAccountProgressStatus,
  IntelligenceColorMap
> = {
  [IntelligenceAccountProgressStatus.SUCCESS]:
    IntelligenceColorMap.TextPositive,
  [IntelligenceAccountProgressStatus.WARNING]: IntelligenceColorMap.TextWarning,
  [IntelligenceAccountProgressStatus.DANGER]: IntelligenceColorMap.TextNegative
};
